import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import CreateDeliveryOptionForm from '../../../modules/deliveryOptions/components/CreateDeliveryOptionForm';

const CreateDeliveryOption = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const title = id ? t('edit_delivery_option') : t('create_delivery_option');

  useEffect(() => {
    dispatch(setBreadCrumbsData({ page_title: title }));
  }, [dispatch, title]);

  return (
    <div>
      <CreateDeliveryOptionForm />
    </div>
  );
};

export default CreateDeliveryOption;
